import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {handleImageUrl, slugify} from "../../helpers";
import {LangContext} from "../../App";

const AbroadItem = ({tour,path}) => {
    const lang = useContext(LangContext)
    if (!tour) return null;
    const slug = slugify(tour?.title || '')
    const image = handleImageUrl(tour.thumbnail)
    return (
        <Link to={`/${lang}/${path}/${tour.id}/${slug}`} className='abroad-item'>
            {image && <img src={image} alt={tour.title}/>}
            <h2>{tour.title}</h2>
            <div className="count">
                {tour.price} $
            </div>
        </Link>
    );
};

export default AbroadItem;